export const AVAILABLE_SURAHS = [
    { id: 1, name: "Surah Al-Fatiha (The Opening)", weight: 1 },   // long
    { id: 108, name: "Surah Al-Kawthar (The Abundance)", weight: 5 }, // very short
    { id: 110, name: "Surah An-Nasr (The Help)", weight: 4 },
    { id: 112, name: "Surah Al-Ikhlas (The Sincerity)", weight: 5 },
    { id: 114, name: "Surah An-Nas (Mankind)", weight: 5 },
];
